import TiresAPI, { ITiresSizes } from "../../api/tires.api";
import Index from "./tire-calculator/tire-calculator.container";

function TireCalculator(props: ITiresSizes) {
  return <Index {...props} />;
}

TireCalculator.getInitialProps = async () => {
  const { data } = await TiresAPI.getAllTireSizes();
  const tireSizeResponse = data.tireSizes.map((tireSize: any) => ({
    size: tireSize,
  }));
  return { tireSizes: tireSizeResponse };
};

export default TireCalculator;
